import classNames from "classnames";
import { DisplayedMessages } from "../ChatComponents/DisplayedMessages";
import { MessageSendingInput } from "../ChatComponents/MessageSendingInput";
import { SendMessageButton } from "../ChatComponents/MessageSendingInput/Actions/SendMessageButton";
import { ChatModelsSelection } from "./Components/ChatModelsSelection";
import { useChatCompletions } from "./hook/use-chat-completions";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export const ChatCompletions = ({ className }: Props) => {
  const {
    selectedModel,
    messages,
    userMessage,
    isMessageLoading,
    handleKeyDown,
    handleSelectModel,
    handleChangeMessage,
    handleSendChatMessage,
  } = useChatCompletions();
  return (
    <div className={classNames(styles.container, className)}>
      <DisplayedMessages
        messages={messages}
        isLoading={isMessageLoading}
        className={styles.chat}
      />
      <MessageSendingInput
        sendValue={userMessage}
        onChange={handleChangeMessage}
        handleKeyDown={handleKeyDown}
        rows={4}
        extraContent={
          <ChatModelsSelection
            modelId={selectedModel?.id ?? "free"}
            updateObject={handleSelectModel}
          />
        }
        actions={<SendMessageButton sendMessage={handleSendChatMessage} />}
        actionWrapperClassName={styles["chat-completion-action-wrapper"]}
      />
    </div>
  );
};
